// removed by extract-text-webpack-plugin
module.exports = {"backButton":"EZF-h"};


//////////////////
// WEBPACK FOOTER
// ./containers/stages/IdentificationStage/styles.scss
// module id = 699
// module chunks = 0